import { useParams } from 'react-router-dom';
import { useAuthStore } from '../stores';

/**
 * Returns the active guild ID from URL params or app state.
 * After login + redirect, the real guild ID is always in the URL.
 */
export function useGuildId(): string {
  const { guildId: urlGuildId } = useParams<{ guildId?: string }>();
  const guildId = useAuthStore(s => s.guildId);
  return urlGuildId ?? guildId ?? '';
}
